import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function PhoneField({
  required = false,
  value,
  onChange,
  defaultCountry = "fr",
  testId = "customer-phone",
  error,
}) {
  return (
    <div className="space-y-1">

      <div className="w-full">
        <PhoneInput
          country={defaultCountry}
          value={value}
          onChange={(val) => onChange(val)}
          enableSearch
          copyNumbersOnly
          autoFormat
          inputProps={{
            required,
            "data-testid": testId,
          }}
          containerClass="w-full"
          // Tailwind overrides (note the !important via !)
          inputClass="!w-full !h-12 !text-sm !border !border-slate-300 !rounded-md !pl-20 focus:!outline-none focus:!ring-2 focus:!ring-slate-400 text-max-length-12 "
          buttonClass="!h-12 !border !border-slate-300 !rounded-md !bg-white !p-3"
          dropdownClass="!text-sm"
          searchClass="!text-sm"
        />

        {error ? (
          <p className="text-xs text-red-500 mt-1">{error}</p>
        ) : null}
      </div>
    </div>
  );
}
